<template>
    <section class="main-box">
      <div class="m-title">地磅职能收料系统</div>
      <table class="m-mess" v-for="(item,index) in storeObj" :key="index" cellspacing="1">
        <tr class="tdbg"><td>车辆识别</td><td>{{item.CarNum}}</td><td></td></tr>
        <tr class="tdbg"><td>材料名称</td><td>{{item.Material}}</td><td></td></tr>
        <tr class="tdbg"><td>毛重</td><td>{{item.LoadInWeight}}</td><td>吨</td></tr>
        <tr class="tdbg"><td>车重</td><td>{{item.LoadOutWeight}}</td><td>吨</td></tr>
        <tr class="tdbg"><td>净重</td><td>{{item.MaterialWeight}}</td><td>吨</td></tr>
        <tr class="tdbg"><td>单价</td><td>{{item.UnitPrice}}</td><td>元/吨</td></tr>
        <tr class="tdbg"><td>总价</td><td>{{item.TotalPrice}}</td><td>元/吨</td></tr>
      </table>
    </section>
</template>

<script>
    import {loaderStore} from '../../api/api'
    export default {
        name: "Machine",
      data(){
        return {
          storeObj:[]
        }
      },
      mounted() {
        loaderStore({}, this.GLOBAL.header).then(result => {
            this.storeObj = result.data.data;
        })
      }
    }
</script>

<style scoped>
.m-mess{
  margin: auto;
  width: 400px;
  background: #b8b8b8;
  margin-top: 20px;
  overflow-y: scroll;
}
.m-mess tr {
  height: 30px;
  text-align: center;
}
.trbg {
  background: #DDE5D4
}
.tdbg td {
  background: #f8f8f8
}
  .m-title{
    margin: auto;
    width: 400px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/Machine.vue